import styled from "styled-components";

// Keeps section content centered and capped on wide screens while section backgrounds run full width.
const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: calc(var(--maxContentWidth) + var(--gutter) * 2);
  margin: 0 auto;
  padding: 0 var(--gutter);
`;

export default Container;
